/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type CartItemPricing_user$ref = any;
type CartItemTitle_user$ref = any;
export type CartItem_user$ref = any;
export type CartItem_user = {
    readonly serviceId: string | null;
    readonly " $fragmentRefs": CartItemPricing_user$ref & CartItemTitle_user$ref;
    readonly " $refType": CartItem_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "CartItem_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "serviceId",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "FragmentSpread",
            "name": "CartItemPricing_user",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "CartItemTitle_user",
            "args": null
        }
    ]
} as any);
(node as any).hash = '8ceb8cad16feb4580f9ac8b552de724d';
export default node;
